import {
    getFirestore,
    doc,
    collection,
    getDoc,
    getDocs,
    query,
    getCountFromServer,
    updateDoc,
    setDoc,
    addDoc,
    deleteDoc
} from "firebase/firestore";
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getFunctions, httpsCallable} from "firebase/functions";
import * as auth from "firebase/auth";
import {getStorage, ref, getDownloadURL, uploadString, uploadBytesResumable, deleteObject } from "firebase/storage";


//Configure Firebase
//Start: For Production
const firebaseConfig = process.env.NODE_ENV == 'production'? {
        apiKey: "AIzaSyCtZC_Sg48yt07uF8UgOtvfmtH41ECKaCM",
        authDomain: "pappyon-c59f8.firebaseapp.com",
        databaseURL: "https://pappyon-c59f8.firebaseio.com",
        projectId: "pappyon-c59f8",
        storageBucket: "pappyon-c59f8.appspot.com",
        messagingSenderId: "728048238922",
        appId: "1:728048238922:web:0d5f0a3098f7e23d1a41b3",
        measurementId: "G-3HLNH3Z7WY"
    }
    //End: For Production
    //Start: For Development
    : {
        apiKey: "AIzaSyC3T43-Es6RF5w_c-roI_Zc_2hO5NQxv3A",
        authDomain: "pappyon-staging.firebaseapp.com",
        projectId: "pappyon-staging",
        storageBucket: "pappyon-staging.appspot.com",
        messagingSenderId: "354022891327",
        appId: "1:354022891327:web:080230423047b77c323d8a",
        measurementId: "G-3HMJCN7H70"
    };
//End: For Development
// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
getAnalytics(firebaseApp)

const db = getFirestore(firebaseApp);

export function getDb() {
    return db;
}

const functions = getFunctions(firebaseApp);

const storage = getStorage(firebaseApp);

export function getStorageRef(path) {
    return ref(storage, path);
}

export function uploadFileInStorage(ref, file, metadata) {
    return uploadBytesResumable(ref, file, metadata)
}


/*
export function uploadFileInStorageWithMetadata(ref, file, metadata) {
    return uploadBytes(ref, file, metadata)
}
*/

export function uploadStringInStorage(ref, data, format, metadata) {
    return uploadString(ref, data, format, metadata)
}

export function getDownloadUrlForRef(ref) {
    return getDownloadURL(ref);
}

export function deleteFileInStorage(ref) {
    return deleteObject(ref);
}

export function getHttpsCallable(name) {
    return httpsCallable(functions, name);
}

export function getAuth() {return auth.getAuth(firebaseApp)}


export function getCollectionRef(collectionName) {
    return collection(db, collectionName);
}

export function getNewDocRefByCollectionName(collectionName) {
    const docRef =doc(getCollectionRef(collectionName));
    return docRef;
}

export function getNewDocRefByCollectionRef(collectionRef) {
    const docRef =doc(collectionRef);
    return docRef;
}


export function getDocRef(collectionName, docId) {
    return doc(getCollectionRef(collectionName), docId);
}

export function getDocById(collectionName, id) {
    return getDoc(getDocRef(collectionName, id));
}

/*
export function getQueryByCollectionName(collectionName, ...queryConstraints) {
    return getDocs(query(getCollectionRef(collectionName), ...queryConstraints));
}
*/

export function setDocByDocId(collectionName, docId, data) {
    return setDoc(getDocRef(collectionName, docId), data);
}


export function updateDocByName(collectionName, docId, data) {
    return updateDoc(getDocRef(collectionName, docId), data);
}

export function addDocByName(collectionName, data) {
    return addDoc(getCollectionRef(collectionName), data);
}

export function queryByCollectionName(collectionName, ...queryConstraints) {
    return query(getCollectionRef(collectionName), ...queryConstraints);
}

export function getQueryByCollectionName(collectionName, ...queryConstraints) {
    return getDocs(queryByCollectionName(collectionName, ...queryConstraints));
}

export function deleteDocByName(collectionName, docId) {
    return deleteDoc(getDocRef(collectionName, docId));
}

/*
    * Event Collection
    * All the queries related to event collection are placed here till the next documentation comment
    * 1. getEventDoc(eventId) - get event document
    * 2. getEventCollection() - get all events
    * 3. eventDocRef(eventId) - get event document reference
    * 4. eventCollectionRef - get event collection reference
    * 5. queryEventCollection() - query event collection
    * 6. getQueryEventCollection() - get query event collection
 */

export const eventCollectionRef = getCollectionRef( "events");

export function eventDocRef(eventId) {
    return doc(eventCollectionRef, eventId);
}

export function getEventDoc(eventId) {
    return getDoc(eventDocRef(eventId));
}

export function getEventCollection() {
    return getDocs(eventCollectionRef);
}

export function queryEventCollection(...queryConstraints) {
    return query(eventCollectionRef, ...queryConstraints);
}

export function getQueryEventCollection(...queryConstraints) {
    return getDocs(queryEventCollection(...queryConstraints));
}

export function setEventDoc(eventId, data, options) {
    return setDoc(eventDocRef(eventId), data, options);
}

export function updateEventDoc(eventId, data) {
    return updateDoc(eventDocRef(eventId), data);
}

export function deleteEventDoc(eventId) {
    return deleteDoc(eventDocRef(eventId));
}


/*
    * Business Portal Access Collection
    * All the queries related to business portal access collection are placed here till the next documentation comment
    * 1. getBusinessPortalAccessDoc(uid) - get business portal access document
    * 2. getBusinessPortalAccessCollection() - get all business portal access
    * 3. businessPortalAccessDocRef(uid) - get business portal access document reference
    * 4. businessPortalAccessCollectionRef - get business portal access collection reference
    * 5. queryBusinessPortalAccessCollection() - query business portal access collection
    * 6. getQueryBusinessPortalAccessCollection() - get query business portal access collection
    * 7. updateBusinessPortalAccessDoc(uid, data) - update business portal access document
 */

export const businessPortalAccessCollectionRef = getCollectionRef("business_portal_access");

export function businessPortalAccessDocRef(uid) {
    return doc(businessPortalAccessCollectionRef, uid);
}

export function getBusinessPortalAccessDoc(uid) {
    return getDoc(businessPortalAccessDocRef(uid));
}

export function getBusinessPortalAccessCollection() {
    return getDocs(businessPortalAccessCollectionRef);
}

export function queryBusinessPortalAccessCollection(...queryConstraints) {
    return query(businessPortalAccessCollectionRef, ...queryConstraints);
}

export function getQueryBusinessPortalAccessCollection(...queryConstraints) {
    return getDocs(queryBusinessPortalAccessCollection(...queryConstraints));
}

export function updateBusinessPortalAccessDoc(uid, data) {
    return updateDoc(businessPortalAccessDocRef(uid), data);
}

export function setBusinessPortalAccessDoc(uid, data, options) {
    return setDoc(businessPortalAccessDocRef(uid), data, options);
}

export function addBusinessPortalAccessDoc(data) {
    return addDoc(businessPortalAccessCollectionRef, data);
}

export function deleteBusinessPortalAccessDoc(uid) {
    return deleteDoc(businessPortalAccessDocRef(uid));
}

/*
    * Users Collection
    * All the queries related to users collection are placed here till the next documentation comment
    * 1. getUsersDoc(uid) - get users document
    * 2. getUsersCollection() - get all users
    * 3. usersDocRef(uid) - get users document reference
    * 4. usersDocCollectionRef - get users collection reference
    * 5. updateUserDoc(uid, data) - update user document

 */

export const usersDocCollectionRef = getCollectionRef("users");

export function usersDocRef(uid) {
    return doc(usersDocCollectionRef, uid);
}

export function getUsersDoc(uid) {
    return getDoc(usersDocRef(uid));
}

export function getUsersCollection() {
    return getDocs(usersDocCollectionRef);
}


export function updateUserDoc(uid, data) {
    return updateDoc(usersDocRef(uid), data);
}

export function setUsersDoc(uid, data, options) {
    return setDoc(usersDocRef(uid), data, options);
}

export function queryUsersCollection(...queryConstraints) {
    return query(usersDocCollectionRef, ...queryConstraints);
}

export function getQueryUsersCollection(...queryConstraints) {
    return getDocs(queryUsersCollection(...queryConstraints));
}

/*
    * Connections Collection
    * All the queries related to connections collection are placed here till the next documentation comment
    * 1. connectionsDocRef(uid) - get connections document reference
    * 2. getConnectionsDoc(uid) - get connections document
    * 3. getConnectionsCollection() - get all connections
    * 4. connectionsCollectionRef - get connections collection reference
    * 5. queryConnectionsCollection() - query connections collection
    * 6. getQueryConnectionsCollection() - get query connections collection
    * 7. getCountConnectionsCollection() - get count of query connections collection
    * 8. updateConnectionsDoc(uid, data) - update connections document
 */

export const connectionsCollectionRef = getCollectionRef("connections");

export function connectionsDocRef(uid) {
    return doc(connectionsCollectionRef, uid);
}

export function getConnectionsDoc(uid) {
    return getDoc(connectionsDocRef(uid));
}

export function getConnectionsCollection() {
    return getDocs(connectionsCollectionRef);
}

export function queryConnectionsCollection(...queryConstraints) {
    return query(connectionsCollectionRef, ...queryConstraints);
}

export function getQueryConnectionsCollection(...queryConstraints) {
    return getDocs(queryConnectionsCollection(...queryConstraints));
}

export function getCountConnectionsCollection(...queryConstraints) {
    return getCountFromServer(queryConnectionsCollection(...queryConstraints));
}

export function updateConnectionsDoc(uid, data) {
    return updateDoc(connectionsDocRef(uid), data);
}

/*
    * Event Attendees Collection
    * All the queries related to event attendees collection are placed here till the next documentation comment
    * 1. eventAttendeesDocRef(eventId) - get event attendees document reference
    * 2. getEventAttendeesDoc(eventId) - get event attendees document
    * 3. getEventAttendeesCollection() - get all event attendees
    * 4. queryEventAttendeesCollection() - query event attendees collection
    * 5. getQueryEventAttendeesCollection() - get query event attendees collection

 */

export const eventAttendeesCollectionRef = getCollectionRef("event_attendees");

export function eventAttendeesDocRef(eventId) {
    return doc(eventAttendeesCollectionRef, eventId);
}

export function getEventAttendeesDoc(eventId) {
    return getDoc(eventAttendeesDocRef(eventId));
}

export function getEventAttendeesCollection() {
    return getDocs(eventAttendeesCollectionRef);
}

export function queryEventAttendeesCollection(...queryConstraints) {
    return query(eventAttendeesCollectionRef, ...queryConstraints);
}

export function getQueryEventAttendeesCollection(...queryConstraints) {
    return getDocs(queryEventAttendeesCollection(...queryConstraints));
}

export function updateEventAttendeesDoc(uid, data) {
    return updateDoc(eventAttendeesDocRef(uid), data);
}

export function deleteEventAttendeesDoc(uid) {
    return deleteDoc(eventAttendeesDocRef(uid));
}

/*
    * Sponsor Collection
    * All the queries related to sponsor collection are placed here till the next documentation comment
    * 1. sponsorDocRef(sponsorId) - get sponsor document reference
    * 2. getSponsorDoc(sponsorId) - get sponsor document
    * 3. getSponsorCollection() - get all sponsors
    * 4. querySponsorCollection() - query sponsor collection
    * 5. getQuerySponsorCollection() - get query sponsor collection
 */

export const sponsorCollectionRef = getCollectionRef("sponsors");

export function sponsorDocRef(sponsorId) {
    return doc(sponsorCollectionRef, sponsorId);
}

export function getSponsorDoc(sponsorId) {
    return getDoc(sponsorDocRef(sponsorId));
}

export function getSponsorCollection() {
    return getDocs(sponsorCollectionRef);
}

export function querySponsorCollection(...queryConstraints) {
    return query(sponsorCollectionRef, ...queryConstraints);
}

export function getQuerySponsorCollection(...queryConstraints) {
    return getDocs(querySponsorCollection(...queryConstraints));
}

/*
    * Featured Companies Collection
    * All the queries related to featured companies collection are placed here till the next documentation comment
    * 1. featuredCompaniesDocRef(companyId) - get featured companies document reference
    * 2. getFeaturedCompaniesDoc(companyId) - get featured companies document
    * 3. getFeaturedCompaniesCollection() - get all featured companies
    * 4. queryFeaturedCompaniesCollection() - query featured companies collection
    * 5. getQueryFeaturedCompaniesCollection() - get query featured companies collection
    * 6. updateFeaturedCompaniesDoc(companyId, data) - update featured companies document
 */

export const featuredCompaniesCollectionRef = getCollectionRef("featuredCompanies");

export function featuredCompaniesDocRef(companyId) {
    return doc(featuredCompaniesCollectionRef, companyId);
}

export function getFeaturedCompaniesDoc(companyId) {
    return getDoc(featuredCompaniesDocRef(companyId));
}

export function getFeaturedCompaniesCollection() {
    return getDocs(featuredCompaniesCollectionRef);
}

export function queryFeaturedCompaniesCollection(...queryConstraints) {
    return query(featuredCompaniesCollectionRef, ...queryConstraints);
}

export function getQueryFeaturedCompaniesCollection(...queryConstraints) {
    return getDocs(queryFeaturedCompaniesCollection(...queryConstraints));
}

export function updateFeaturedCompaniesDoc(companyId, data) {
    return updateDoc(featuredCompaniesDocRef(companyId), data);
}

/*
    * Event Notes Collection
    * All the queries related to event notes collection are placed here till the next documentation comment
    * 1. eventNotesDocRef(eventId) - get event notes document reference
    * 2. getEventNotesDoc(eventId) - get event notes document
    * 3. getEventNotesCollection() - get all event notes
    * 4. queryEventNotesCollection() - query event notes collection
    * 5. getQueryEventNotesCollection() - get query event notes collection
 */

export const eventNotesCollectionRef = getCollectionRef("event_notes");

export function eventNotesDocRef(eventId) {
    return doc(eventNotesCollectionRef, eventId);
}

export function getEventNotesDoc(eventId) {
    return getDoc(eventNotesDocRef(eventId));
}

export function getEventNotesCollection() {
    return getDocs(eventNotesCollectionRef);
}

export function queryEventNotesCollection(...queryConstraints) {
    return query(eventNotesCollectionRef, ...queryConstraints);
}

export function getQueryEventNotesCollection(...queryConstraints) {
    return getDocs(queryEventNotesCollection(...queryConstraints));
}

/*
    * Activities Collection
    * All the queries related to activities collection are placed here till the next documentation comment
    * 1. activitiesDocRef(activityId) - get activities document reference
    * 2. getActivitiesDoc(activityId) - get activities document
    * 3. getActivitiesCollection() - get all activities
    * 4. queryActivitiesCollection() - query activities collection
    * 5. getQueryActivitiesCollection() - get query activities collection
 */

export const activitiesCollectionRef = getCollectionRef("activities");

export function activitiesDocRef(activityId) {
    return doc(activitiesCollectionRef, activityId);
}

export function getActivitiesDoc(activityId) {
    return getDoc(activitiesDocRef(activityId));
}

export function getActivitiesCollection() {
    return getDocs(activitiesCollectionRef);
}

export function queryActivitiesCollection(...queryConstraints) {
    return query(activitiesCollectionRef, ...queryConstraints);
}

export function getQueryActivitiesCollection(...queryConstraints) {
    return getDocs(queryActivitiesCollection(...queryConstraints));
}

/*
    * Business Profiles Collection
    * All the queries related to business profiles collection are placed here till the next documentation comment
    * 1. businessProfilesDocRef(businessProfileId) - get business profiles document reference
    * 2. getBusinessProfilesDoc(businessProfileId) - get business profiles document
    * 3. getBusinessProfilesCollection() - get all business profiles
    * 4. queryBusinessProfilesCollection() - query business profiles collection
    * 5. updateBusinessProfilesDoc(businessProfileId, data) - update business profiles document
 */

export const businessProfilesCollectionRef = getCollectionRef("business_profiles");

export function businessProfilesDocRef(businessProfileId) {
    return doc(businessProfilesCollectionRef, businessProfileId);
}

export function getBusinessProfilesDoc(businessProfileId) {
    return getDoc(businessProfilesDocRef(businessProfileId));
}

export function getBusinessProfilesCollection() {
    return getDocs(businessProfilesCollectionRef);
}

export function queryBusinessProfilesCollection(...queryConstraints) {
    return query(businessProfilesCollectionRef, ...queryConstraints);
}

export function getQueryBusinessProfilesCollection(...queryConstraints) {
    return getDocs(queryBusinessProfilesCollection(...queryConstraints));
}

export function updateBusinessProfilesDoc(businessProfileId, data) {
    return updateDoc(businessProfilesDocRef(businessProfileId), data);
}

export function addBusinessProfilesDoc(data) {
    return addDoc(businessProfilesCollectionRef, data);
}


/*
    * Business Portal Notifications Collection
    * All the queries related to business portal notifications collection are placed here till the next documentation comment
    * 1. businessPortalNotificationsDocRef(notificationId) - get business portal notifications document reference
    * 2. getBusinessPortalNotificationsDoc(notificationId) - get business portal notifications document
    * 3. getBusinessPortalNotificationsCollection() - get all business portal notifications
    * 4. queryBusinessPortalNotificationsCollection() - query business portal notifications collection

 */

export const businessPortalNotificationsCollectionRef = getCollectionRef("business_portal_notifications");

export function businessPortalNotificationsDocRef(notificationId) {
    return doc(businessPortalNotificationsCollectionRef, notificationId);
}

export function getBusinessPortalNotificationsDoc(notificationId) {
    return getDoc(businessPortalNotificationsDocRef(notificationId));
}

export function getBusinessPortalNotificationsCollection() {
    return getDocs(businessPortalNotificationsCollectionRef);
}

export function queryBusinessPortalNotificationsCollection(...queryConstraints) {
    return query(businessPortalNotificationsCollectionRef, ...queryConstraints);
}

export function getQueryBusinessPortalNotificationsCollection(...queryConstraints) {
    return getDocs(queryBusinessPortalNotificationsCollection(...queryConstraints));
}


/*
    * Business Portal Stats Collection
    * All the queries related to business portal stats collection are placed here till the next documentation comment
    * 1. businessPortalStatsDocRef(statsId) - get business portal stats document reference
 */

export const businessPortalStatsCollectionRef = getCollectionRef("business_portal_stats");

export function businessPortalStatsDocRef(statsId) {
    return doc(businessPortalStatsCollectionRef, statsId);
}

export function getBusinessPortalStatsDoc(statsId) {
    return getDoc(businessPortalStatsDocRef(statsId));
}

export function getBusinessPortalStatsCollection() {
    return getDocs(businessPortalStatsCollectionRef);
}

export function updateBusinessPortalStatsDoc(statsId, data) {
    return updateDoc(businessPortalStatsDocRef(statsId), data);
}

export function setBusinessPortalStatsDoc(statsId, data) {
    return setDoc(businessPortalStatsDocRef(statsId), data);
}

export function addBusinessPortalStatsDoc(data) {
    return addDoc(businessPortalStatsCollectionRef, data);
}

/*
    * Employer Update Requests Collection
    *
 */

export const employerUpdateRequests = getCollectionRef("employer_update_requests");

export function employerUpdateRequestsDocRef(requestId) {
    return doc(employerUpdateRequests, requestId);
}

export function getEmployerUpdateRequestsDoc(requestId) {
    return getDoc(employerUpdateRequestsDocRef(requestId));
}

export function getEmployerUpdateRequestsCollection() {
    return getDocs(employerUpdateRequests);
}

export function queryEmployerUpdateRequestsCollection(...queryConstraints) {
    return query(employerUpdateRequests, ...queryConstraints);
}

export function getQueryEmployerUpdateRequestsCollection(...queryConstraints) {
    return getDocs(queryEmployerUpdateRequestsCollection(...queryConstraints));
}

export function updateEmployerUpdateRequestsDoc(requestId, data) {
    return updateDoc(employerUpdateRequestsDocRef(requestId), data);
}


/*
    * Business Cards Collection
    * All the queries related to business cards collection are placed here till the next documentation comment
    * 1. businessCardsDocRef(cardId) - get business cards document reference
    * 2. getBusinessCardsDoc(cardId) - get business cards document
    * 3. getBusinessCardsCollection() - get all business cards
    * 4. queryBusinessCardsCollection() - query business cards collection
    * 5. getQueryBusinessCardsCollection() - get query business cards collection
 */

export const businessCardsCollectionRef = getCollectionRef("business_cards");

export function getNewBusinessCardDoc() {
    return doc(businessCardsCollectionRef);
}

export function businessCardsDocRef(cardId) {
    return doc(businessCardsCollectionRef, cardId);
}

export function getBusinessCardsDoc(cardId) {
    return getDoc(businessCardsDocRef(cardId));
}

export function getBusinessCardsCollection() {
    return getDocs(businessCardsCollectionRef);
}

export function queryBusinessCardsCollection(...queryConstraints) {
    return query(businessCardsCollectionRef, ...queryConstraints);
}

export function getQueryBusinessCardsCollection(...queryConstraints) {
    return getDocs(queryBusinessCardsCollection(...queryConstraints));
}

export function updateBusinessCardsDoc(cardId, data) {
    return updateDoc(businessCardsDocRef(cardId), data);
}

export function deleteBusinessCardsDoc(uid) {
    return deleteDoc(businessCardsDocRef(uid));
}

/*
     * Speaker Collection
     * All the queries related to speaker collection are placed here till the next documentation comment
     * 1. speakerDocRef(speakerId) - get speaker document reference
     * 2. getSpeakerDoc(speakerId) - get speaker document
     * 3. getSpeakerCollection() - get all speakers
     * 4. querySpeakerCollection() - query speaker collection
     * 5. getQuerySpeakerCollection() - get query speaker collection
 */


export const speakerCollectionRef = getCollectionRef("speakers");

export function speakerDocRef(speakerId) {
    return doc(speakerCollectionRef, speakerId);
}

export function getSpeakerDoc(speakerId) {
    return getDoc(speakerDocRef(speakerId));
}

export function getSpeakerCollection() {
    return getDocs(speakerCollectionRef);
}

export function querySpeakerCollection(...queryConstraints) {
    return query(speakerCollectionRef, ...queryConstraints);
}

export function getQuerySpeakerCollection(...queryConstraints) {
    return getDocs(querySpeakerCollection(...queryConstraints));
}

export function updateSpeakerDoc(speakerId, data) {
    return updateDoc(speakerDocRef(speakerId), data);
}

export function setSpeakerDoc(speakerId, data, options) {
    return setDoc(speakerDocRef(speakerId), data, options);
}

export function addSpeakerDoc(data) {
    return addDoc(speakerCollectionRef, data);
}

/*
    * Business Network Collection
    * All the queries related to business network collection are placed here till the next documentation comment
    * 1. yourBusinessNetworkDocRef(id) - get your business network document reference
    * 2. getYourBusinessNetworkDoc(id) - get your business network document
    * 3. getYourBusinessNetworkCollection() - get all your business network

 */

export const yourBusinessNetwork = getCollectionRef("your_business_network");

export function yourBusinessNetworkDocRef(id) {
    return doc(yourBusinessNetwork, id);
}

export function getYourBusinessNetworkDoc(id) {
    return getDoc(yourBusinessNetworkDocRef(id));
}

export function getYourBusinessNetworkCollection() {
    return getDocs(yourBusinessNetwork);
}

export function queryYourBusinessNetworkCollection(...queryConstraints) {
    return query(yourBusinessNetwork, ...queryConstraints);
}

export function setYourBusinessNetworkDoc(id, data) {
    return setDoc(yourBusinessNetworkDocRef(id), data);
}

export function updateYourBusinessNetworkDoc(id, data) {
    return updateDoc(yourBusinessNetworkDocRef(id), data);
}

export function deleteYourBusinessNetworkDoc(id) {
    return deleteDoc(yourBusinessNetworkDocRef(id));
}

/*
    * Posts Collection
    * All the queries related to posts collection are placed here till the next documentation comment
    * 1. postDocRef(postId) - get post document reference
    * 2. getPostDoc(postId) - get post document
    * 3. getPostCollection() - get all posts
 */

export const postCollectionRef = getCollectionRef("posts");

export function postDocRef(postId) {
    return doc(postCollectionRef, postId);
}

export function getPostDoc(postId) {
    return getDoc(postDocRef(postId));
}

export function getPostCollection() {
    return getDocs(postCollectionRef);
}

export function queryPostCollection(...queryConstraints) {
    return query(postCollectionRef, ...queryConstraints);
}

export function getQueryPostCollection(...queryConstraints) {
    return getDocs(queryPostCollection(...queryConstraints));
}

export function updatePostDoc(postId, data) {
    return updateDoc(postDocRef(postId), data);
}

export function setPostDoc(postId, data, options) {
    return setDoc(postDocRef(postId), data, options);
}

export function addPostDoc(data) {
    return addDoc(postCollectionRef, data);
}